export const CONSENT_ITEMS = [
  { id: "terms", to: "/terms", label: "consent.termsLabel", hint: "consent.termsHint", link: "legal.terms" },
  { id: "privacy", to: "/privacy", label: "consent.privacyLabel", hint: "consent.privacyHint", link: "legal.privacy" },
  { id: "eula", to: "/eula", label: "consent.eulaLabel", hint: "consent.eulaHint", link: "legal.eula" },
];

export const BIOMETRIC_ITEM = {
  id: "biometric",
  to: "/biometric-consent",
  label: "consent.bioLabel",
  hint: "consent.bioHint",
  link: "legal.biometric",
};
